import React, {FC} from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import useSize from "../../../../common/hooks/useSize";

interface ScoreChartProps {
    apiData: any;
    height?: number;
    width?: number;
}

const ScoreChart: FC<ScoreChartProps> = ({
                                             apiData,
                                             height = 150,
                                             width = 150,
                                         }) => {
    const score = apiData?.score_v2 ? parseFloat(apiData.score_v2) : 0;

    const {width: screenWidth} = useSize();
    const isSmallScreen = screenWidth <= 768;
    const showTitleAndTooltip = height >= 100 && width >= 100;

    const scoreChartOptions = {
        chart: {
            type: "pie",
            height,
            width,
        },
        title: {
            useHTML: true,
            text: showTitleAndTooltip ? `<span class="bs-font">Score</span>` : null,
        },
        exporting: {enabled: false},
        credits: {enabled: false},
        tooltip: {
            enabled: showTitleAndTooltip,
        },
        plotOptions: {
            pie: {
                innerSize: "80%",
                dataLabels: {
                    enabled: false,
                },
                showInLegend: false,
                states: {
                    hover: {
                        enabled: showTitleAndTooltip,
                    },
                },
            },
        },
        series: [
            {
                name: "Score",
                colorByPoint: true,
                data: [
                    {name: "Score", y: score},
                    {name: "Remaining", y: 100 - score, color: "#e0e0e0"},
                ],
            },
        ],
    };

    return (
        <div style={{position: "relative"}}>
            <HighchartsReact highcharts={Highcharts} options={scoreChartOptions}/>
            {!isSmallScreen && score !== null && height >= 100 && width >= 100 && (
                <div
                    style={{
                        position: "absolute",
                        top: "58%",
                        left: "48%",
                        transform: "translate(-50%, -50%)",
                        fontSize: isSmallScreen ? "12px" : "18px",
                        fontWeight: "bold",
                        textAlign: "center",
                    }}
                >
                    {score.toFixed(2)}
                </div>
            )}
            {isSmallScreen && (
                <div className="d-flex justify-content-center">
                    {" "}
                    <span className="fs-6 fw-bold">{score.toFixed(2)}</span>
                </div>
            )}
        </div>
    );
};

export default ScoreChart;
